import React from 'react';
import type ProductsJsmFeatureUsageType from '@atlassian/jira-spa-apps-products-jsm-feature-usage/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProductsJsmFeatureUsage = lazyForPaint<typeof ProductsJsmFeatureUsageType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-products-jsm-feature-usage", jiraSpaEntry: "async-products-jsm-feature-usage" */ '@atlassian/jira-spa-apps-products-jsm-feature-usage'
		),
	),
);

const AsyncProductsJsmFeatureUsage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProductsJsmFeatureUsage}
		pageId="products-jsm-feature-usage"
		shouldShowSpinner={false}
	/>
);

export default AsyncProductsJsmFeatureUsage;
